var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function({hover}){return [_c('div',{staticClass:"cursorPointer"},[_c('app-icon',{staticClass:"component-container",class:hover ? 'red' : 'appWhite',attrs:{"color":hover ? 'appWhite' : 'red',"icon":"close","size":"32","title":"Close"}})],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }